import { useEffect } from 'react';
import { Button, Text } from '@nimbus-ds/components';
import {
  PromotionType,
  PromotionTypes,
} from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { AlertSessionStorage } from 'App/components';
import { useTranslationMarketing } from '../../hook';
import { useShowNewPromoAlert } from '../hooks';

interface NewPromoAlertProps {
  onClick: (type: PromotionType) => void;
  onRemove: (type: PromotionType) => void;
  onShow: (type: PromotionType) => void;
}

export function NewPromoAlert({
  onClick,
  onRemove,
  onShow,
}: Readonly<NewPromoAlertProps>) {
  const type = PromotionTypes.PERCENTAGE_OFF;

  const t = useTranslationMarketing(`promotions.adoptionAlert.${type}`);
  const showNewPromoAlert = useShowNewPromoAlert(type);

  useEffect(() => {
    if (showNewPromoAlert) {
      onShow(type);
    }
  }, [onShow, showNewPromoAlert, type]);

  if (!showNewPromoAlert) return null;

  return (
    <AlertSessionStorage
      appearance="primary"
      title={t('title')}
      keyName="showAdoptionAlert"
      onRemove={() => onRemove(type)}
    >
      <Text>{t('text')}</Text>
      <Button onClick={() => onClick(type)}>{t('buttonText')}</Button>
    </AlertSessionStorage>
  );
}
